import expiredLink from '../components/ExpiredLink/en.i18n.json'
import pageNotFound from '../components/PageNotFound/en.i18n.json'
import unexpectedError from '../components/UnexpectedError/en.i18n.json'

export default {
  expiredLink,
  pageNotFound,
  unexpectedError,
}
